var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMaze = function SvgMaze(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 37 36"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.383 12.676a10.538 10.538 0 0 0 14.403 14.43m3.809-3.81a10.538 10.538 0 0 0-14.43-14.402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93 31.71A17.308 17.308 0 0 0 32.2 7.44m-3.152-3.15a17.308 17.308 0 0 0-24.27 24.269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.496 21.392a3.385 3.385 0 1 0 0-6.77 3.385 3.385 0 0 0 0 6.77Z"
  }))));
};
export default SvgMaze;